import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tunnel: '/api/tunnel',
  environment: import.meta.env.VITE_ENV_NAME ?? 'development',
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
